import { Command, Curve3, PlineAttributes, PlineT, TnEngineExtraContext, ViewEditor } from "pytha";
import { CableT } from "../models/CableT";



export class UpdateCableCommand extends Command {
    cable: CableT;
    attribute_before: PlineAttributes[] = [];
    geoCurves_before: Curve3[] = [];
    attribute_after: PlineAttributes[] = [];
    geoCurves_after: Curve3[] = [];
    loop_before: boolean;
    loop_after: boolean;
    extraContext: TnEngineExtraContext;

    constructor(editor: ViewEditor, cable: CableT, cableClone: CableT) {
        super();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.editor = editor;
        this.cable = cable;
        this.attribute_before = [].concat(cable.plineAttributes);
        this.attribute_after = [].concat(cableClone.plineAttributes);
        this.geoCurves_before = [].concat(cable._geoCurves);
        this.geoCurves_after = [].concat(cableClone._geoCurves);
        this.loop_before = cable.loop;
        this.loop_after = cableClone.loop;
    }

    execute(): void {
        if (this.cable == null) return;
        this.cable.set(this.attribute_after, this.geoCurves_after);
        this.cable.setCurves(this.geoCurves_after);
        this.cable.loop = this.loop_after;
        this.cable.needRedraw = true;
        this.cable.getBoundingBox();
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.extraContext.apiContext.createPrimitive(this.cable.toJson());

    }
    undo(): void {
        if (this.cable == null) return;
        this.cable.set(this.attribute_before, this.geoCurves_before);
        this.cable.setCurves(this.geoCurves_before);
        this.cable.loop = this.loop_before;
        this.cable.needRedraw = true;
        this.cable.getBoundingBox();
        this.editor.listeners.signals.needRender.dispatch('redraw');
        this.extraContext.apiContext.createPrimitive(this.cable.toJson());
    }

}
